import {  useEffect, useState, useMemo } from "react";
import {  Link, useParams } from "react-router-dom";
import { useGetProductQuery, useUpdateDistributorProductMutation } from "context/product/productApiSlice"; 
import { Badge } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDAvatar from "dashboard/components/MDAvatar";
import MDBadge from "dashboard/components/MDBadge";
import MDProgress from "dashboard/components/MDProgress";

import { Stack, IconButton } from "@mui/material";

import MDButton from "dashboard/components/MDButton";
import Icon from '@mui/material/Icon';
import Tooltip from '@mui/material/Tooltip';

// Images
import useAlert from "hooks/useAlert";
import useSearch from "hooks/useSearch";
import IosSwitch from "dashboard/examples/Forms/CostumFormFields/IosSwitch";
import DistributorUpdate from "./DistributorUpdate";

const languages =  { fr: 'fr', ar: 'dz', en: 'gb'};

export default function Data({connectedUser}) {

  const [noMoreResults, setNoMoreResults] = useState(false);
  const [updateProduct, {isLoading : distLoading}] = useUpdateDistributorProductMutation();
  const {showAlerts} = useAlert();
  const { category } = useParams();
  const { searchTerm, filterSearch } = useSearch(); // filterSearch

  let productsRows = [];
  let pageCount = 0;
  let productList=[];
  let totalResult = 0;

  const productsQuery = useMemo(
    () => {
      const filter = Object.fromEntries(Object.entries(searchTerm.filters).filter(([key,item]) => ![null, undefined, '', 0].includes(item)));
      if(category) filter.category = category;
      if(connectedUser?.id) filter.distri_userId = connectedUser?.id;
      return({
        page: searchTerm.page,
        filters: JSON.stringify({...filter}),
        productsPerpage: searchTerm.entriesPerpage,
        sortBy:searchTerm.sortBy
     })},
    [searchTerm, category, connectedUser]
  );

  const {
    data: products = [],
    isLoading,
    isSuccess,
    isFetching,
    isError,
    error,
    
  } = useGetProductQuery(productsQuery, {
      // pollingInterval: 60000,
      refetchOnMountOrArgChange: true,
      skip: noMoreResults
  });

  const getProducts = productsDetails => {
    filterSearch(productsDetails)
  }
  
  if (isSuccess) {
    const {productsDetails, entities } = products;
    productList = Object.values(entities);
    pageCount = Number(Math.ceil(productsDetails?.total_results / productsDetails?.productsPerpage ));
    totalResult = productsDetails?.total_results
  }
  
  useEffect(() => {
    if(!products?.length && productsQuery?.page > 1 ) {
      setNoMoreResults(true);
    }

    /* eslint-disable */
    isError ? showAlerts({
      title : "Dashboard Alert",
      type  : "toast",
      msg :  error.data?.error || error.message,
      color :"error"
    }) : null
  }, [isError]);
  
  const handleActivate = (id, active) => updateProduct({id, update: {inStock:Number(active ? 1 : 0)}});
  const handleChanges =  update => updateProduct(update);
  const onDelete =  update  => {
    showAlerts({code:"warning", icon:"warning", title : "Delete Distributor product",msg : "Etes-vous sûr de vouloir supprimer ce produit ?  ", type : "confirm", action: update});
  }
  const proGressStatus = value =>{
    let color;
    if( value >= 80){
      color = "success";
    }else if( value >= 50){
      color = "info";
    }else if( value >= 20){
      color = "warning";
    }else{
      color = "error";
    }
    return color
  }
  const Item = ({ id, image, name , category, lang  }) => (
    <MDBox id={id} display="flex" alignItems="center" lineHeight={1}>
      <Badge color="transparent" sx={{'& .MuiBadge-badge ':{backgroundColor: "transparent !important", p : "0 !important", top : 7, right : 7} }} badgeContent={<MDAvatar sx={{maxHeight :16, maxWidth : 24,  borderRadius:"4px", boxShadow :1}} src={`https://flagcdn.com/w40/${languages[lang]}.png`} alt={lang} variant="square" size="sm"/>} >
        <MDAvatar imgType="product" src={image} name={name} size="lg"  />
      </Badge>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{category || "Tout"}</MDTypography>
      </MDBox>
    </MDBox>
  );
  const Progress = ({ color, value }) => (
    <MDBox display="flex" alignItems="center">
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {value}%
      </MDTypography>
      <MDBox ml={0.5} width="9rem">
        <MDProgress variant="gradient" color={color} value={value} />
      </MDBox>
    </MDBox>
  );
  if (isSuccess) {
    productsRows  =  productList?.map( product => {
      const color = proGressStatus(product.progress);
      return ({
        product: <Item id={product.id} lang={product.lang} image={`${process.env.REACT_APP_PUBLIC_URL}/img/product/${product.selectedImage}`} name={product.productName} category={product.category?.name} />,
        price: (
          <MDTypography component="a" href="#" variant="button" color="text" fontWeight="medium">
            {product.priceShow.original}
          </MDTypography>
        ),
        quantity : (
          <MDBox ml={-1}>
            <MDTypography  variant="h4" color="text" fontWeight="medium">
            {product.quantityShow}
            </MDTypography>
            <MDBadge badgeContent={ product.inStock && (product.dist_quantity ? product.dist_quantity > 0 :  product.quantity > 0) ? "on Stock" : "out of Stock" } 
                color={product.inStock && (product.dist_quantity ? product.dist_quantity > 0 :  product.quantity > 0) ? "success" : "error" } variant="gradient" size="sm" />
          </MDBox>
        ),
        
        status : <Progress color={color} value={isNaN(product.progress) ? 0 : product.progress} />,
        action: (
          <MDTypography component="div" color="text" fontWeight="medium">     
            <Stack direction="row" alignItems="flex-end" spacing={1}>
              <Tooltip title="Fiche technique" placement="top" arrow>
                <IconButton size="medium" component="a" target="_blank" rel="noreferrer" href={`${process.env.REACT_APP_PUBLIC_URL}/sheets/${product.sheetURL}`}><Icon>attach_file_add</Icon></IconButton>
              </Tooltip>
              <IosSwitch checked={product.inStock} action={handleActivate} txt={{active :'On Stock', deactive:"Out"}} attribute={product.id} />
              <Tooltip title="change visibility" placement="top" arrow>
                <MDButton onClick={()=>handleChanges({ id : product.dist_id, update : {visible : Number(product.visible === 1) ? 0 : 1} })}  size="medium" disableRipple={false}  sx={{minHeight:35, minWidth:35, p:.5}}  variant="gradient"  color={product.visible === 1 ? 'success' : "secondary"}><Icon size="medium">{product.visible ? 'visibility' : 'visibility_off'}</Icon></MDButton>
              </Tooltip>
              <Tooltip title="Edit product" placement="top" arrow>
                <DistributorUpdate productName={product.productName} initialState={{ quantity:Number(product.dist_quantity), price : Number(product.dist_price), sold:Number(product.sold)}} id={product.dist_id} handleChanges={handleChanges} isLoading={distLoading} />
              </Tooltip>
              <Tooltip title="Delete product" placement="top" arrow>
                <MDButton size="small" disableRipple sx={{minHeight:35, minWidth:35, p:.5}} onClick={()=>onDelete({id : product.dist_id , update :"delete"})} variant="gradient" color="error"><Icon size="medium">delete</Icon></MDButton>
              </Tooltip>
            </Stack>
          </MDTypography>
        ),
      })}
    );
  }
  
  return {
    pageCount  :  pageCount,
    totalResult,
    changePage : getProducts,
    isLoading : isLoading || isFetching,
    columns: [
        { Header: "product", accessor: "product", width: "25%", align: "left" },
        { Header: "price", accessor: "price", align: "center" },
        { Header: "quantity", accessor: "quantity", align: "center" },
        { Header: "status", accessor: "status", align: "center" },
        { Header: "action", accessor: "action", align: "center" },
      ],

    rows: productsRows,
  };
}
